import { PaxCheckChecklistStatus } from "../../api";

enum ChecklistStatus {
  OnHold = "on-hold",
  Active = "active",
  Finalized = "finalized",
}

export function ChecklistStatusFromApi(
  status: PaxCheckChecklistStatus
): ChecklistStatus {
  switch (status) {
    case PaxCheckChecklistStatus.ACTIVE:
      return ChecklistStatus.Active;
    case PaxCheckChecklistStatus.FINALIZED:
      return ChecklistStatus.Finalized;
    case PaxCheckChecklistStatus.ON_HOLD:
      return ChecklistStatus.OnHold;
  }
}

export default ChecklistStatus;
